import { Story } from "../../../../types";
import StoryButton from "../../../common/story-button/story-button";

type Props = {
  story: Story;
  hideAuthors?: boolean;
  onClick?: () => void;
  disabled?: boolean;
};

const StoryVoteCard = ({ story, hideAuthors, onClick, disabled }: Props) => {
  return (
    <div className="flex-grow">
      <StoryButton
        hideAuthors={hideAuthors}
        story={story}
        onClick={onClick}
        disabled={disabled}
      />
    </div>
  );
};

export default StoryVoteCard;
